/// Параметры Firebase для web. Задаются сборке переменной `VITE_FIREBASE_CONFIG`
/// — целиком тем JSON-объектом, который отдаёт Firebase Console
/// (Project settings → Your apps → SDK setup and configuration → Config).
///
/// В репозитории значений нет намеренно. Технически web-конфиг Firebase не
/// секрет: он попадает в каждый собранный бандл, а доступ ограничивают правила
/// Firestore и коллекция `admins`. Но держать его в исходниках всё равно не
/// стоит — ключ проще ограничить и ротировать, когда он живёт в одном месте,
/// в секретах деплоя.
export interface FirebaseOptions {
  apiKey: string
  appId: string
  messagingSenderId: string
  projectId: string
  authDomain: string
  storageBucket: string
  measurementId?: string
}

const REQUIRED: (keyof FirebaseOptions)[] = [
  'apiKey',
  'appId',
  'messagingSenderId',
  'projectId',
  'authDomain',
  'storageBucket',
]

/// Ошибка здесь должна быть громкой и понятной: без конфига Firebase SDK
/// падает где-то в глубине с невнятным сообщением, и полдня уходит на то,
/// чтобы понять, что забыли переменную сборки.
function readFirebaseOptions(): FirebaseOptions {
  const raw = (import.meta.env.VITE_FIREBASE_CONFIG ?? '').trim()

  if (!raw) {
    throw new Error(
      'Не задан VITE_FIREBASE_CONFIG. Скопируйте .env.example в .env.development ' +
        'и впишите конфиг из Firebase Console (Project settings → SDK setup and configuration).',
    )
  }

  let parsed: unknown
  try {
    parsed = JSON.parse(raw)
  } catch {
    throw new Error('VITE_FIREBASE_CONFIG не разбирается как JSON — проверьте кавычки и экранирование.')
  }

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('VITE_FIREBASE_CONFIG должен быть JSON-объектом.')
  }

  const config = parsed as Record<string, unknown>
  const missing = REQUIRED.filter((key) => typeof config[key] !== 'string' || !config[key])
  if (missing.length > 0) {
    throw new Error(`В VITE_FIREBASE_CONFIG не хватает полей: ${missing.join(', ')}.`)
  }

  return config as unknown as FirebaseOptions
}

export const firebaseOptions = readFirebaseOptions()
